/**
 *
 * Asynchronously loads the component for AttendanceHistory
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AttendanceHistory = lazyLoad(
  () => import('./index'),
  module => module.AttendanceHistory,
);
